import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  copyEmails() {
    console.log('Copy emails button clicked') // Debug log

    // Get all table rows from the users table
    const tableRows = document.querySelectorAll('tbody tr:not([colspan])')
    console.log('Found table rows:', tableRows.length) // Debug log

    const emails = []

    tableRows.forEach((row, rowIndex) => {
      const cells = row.querySelectorAll('td')
      console.log(`Row ${rowIndex} has ${cells.length} cells`) // Debug log

      // Look for cells that contain email-like content with @ symbol
      cells.forEach((cell, cellIndex) => {
        // First try the specific email column structure
        const emailContainer = cell.querySelector('div.flex.items-center.space-x-2')
        if (emailContainer) {
          console.log(`Found email container in row ${rowIndex}, cell ${cellIndex}`) // Debug log
          const emailSpan = emailContainer.querySelector('span')
          if (emailSpan && emailSpan.textContent.includes('@')) {
            const email = emailSpan.textContent.trim()
            console.log(`Found email: ${email}`) // Debug log
            if (email && !emails.includes(email)) {
              emails.push(email)
            }
          }
        } else {
          // Fallback: look for any text content that looks like an email
          const cellText = cell.textContent.trim()
          if (cellText.includes('@') && cellText.includes('.')) {
            console.log(`Found potential email in cell text: ${cellText}`) // Debug log
            // Simple email regex to validate
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (emailRegex.test(cellText) && !emails.includes(cellText)) {
              console.log(`Valid email found: ${cellText}`) // Debug log
              emails.push(cellText)
            }
          }
        }
      })
    })

    console.log('Found emails:', emails) // Debug log

    if (emails.length === 0) {
      alert('No email addresses found on this page.')
      return
    }

    // Join emails with commas and spaces for email client "to:" field
    const emailString = emails.join(', ')

    // Copy to clipboard
    navigator.clipboard.writeText(emailString).then(() => {
      this.showSuccessFeedback(emails.length)
    }).catch((error) => {
      console.error('Clipboard error:', error)
      alert('Failed to copy emails to clipboard. Please try again.')
    })
  }

  showSuccessFeedback(emailCount) {
    const button = this.buttonTarget
    const originalHTML = button.innerHTML

    button.innerHTML = `
      <svg class="-ml-0.5 mr-2 h-4 w-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
      Copied ${emailCount} emails!
    `
    button.classList.add('bg-green-50', 'border-green-300', 'text-green-700')
    button.classList.remove('bg-white', 'border-gray-300', 'text-gray-700')

    setTimeout(() => {
      button.innerHTML = originalHTML
      button.classList.remove('bg-green-50', 'border-green-300', 'text-green-700')
      button.classList.add('bg-white', 'border-gray-300', 'text-gray-700')
    }, 3000)
  }
}
